import { PublicResource, Related, ResourceBase } from '../../resource-types';
import { RawModel } from '../schema';

export interface Thumbnail extends PublicResource, ResourceBase {
  timestamp: number;
  relationships: {
    asset: Related<'asset'>;
  };
}

export const thumbnail: RawModel = {
  type: 'thumbnail',
  plural: 'thumbnail',
  JSONApi: true,
  useWorker: true,
  attributes: {
    id: 'UUID',
    timestamp: 'number'
  },
  relationships: {
    asset: {
      type: 'asset',
      binding: ['one', 'one'],
      reverse: 'thumbnail'
    }
  }
};
